'use strict';

angular.module('user')
    .component('loginForm', {
        templateUrl: 'js/modules/user/components/login-form/template.html',
        controller: 'ApiAuthLoginController',
        controllerAs: 'LoginController',
        bindings: {
            message: '<',
            warn: '<',
            error: '<',
            onLogin: '&',
        },
    });
